import { render, staticRenderFns } from "./ScreenVideo.vue?vue&type=template&id=52f42926&scoped=true&"
import script from "./ScreenVideo.vue?vue&type=script&lang=ts&"
export * from "./ScreenVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenVideo.vue?vue&type=style&index=0&id=52f42926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f42926",
  null
  
)

export default component.exports